import "./css/blog.scss";
import {debounce} from "lodash";

// this is our masonry layout
function resizeGridItem(item) {
    let grid = document.getElementsByClassName("of-news-article-grid")[0];
    let rowHeight = parseInt(
        window.getComputedStyle(grid).getPropertyValue("grid-auto-rows")
    );
    let rowGap = parseInt(
        window.getComputedStyle(grid).getPropertyValue("grid-row-gap")
    );
    let rowSpan = Math.ceil(
        (item
            .querySelector(".of-news-article-grid__item-content")
            .getBoundingClientRect().height +
            rowGap) /
            (rowHeight + rowGap)
    );
    item.style.gridRowEnd = "span " + rowSpan;
}

function resizeAllGridItems() {
    let allItems = document.getElementsByClassName(
        "of-news-article-grid__item"
    );
    for (let x = 0; x < allItems.length; x++) {
        resizeGridItem(allItems[x]);
    }
}
document.addEventListener("blog:articles-changed", () => {
    resizeAllGridItems();
    window.lazyLoadInstance.update();
});

document.addEventListener("turbo:load", () => {
    resizeAllGridItems();
});

// debounce the resize event
window.addEventListener("resize", debounce(resizeAllGridItems, 250));
